import { styled } from '@mui/system';

export const Root = styled('div')`
  display: grid;
  place-items: center;
  height: 100%;
  background: #F9FAF9;
`;

export const Container = styled('section')`
  display: flex;
  max-width: 520px;
  padding: 40px;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  border-radius: 10px;
  background-color: #FFFFFF;
`;